import { guid } from '@progress/kendo-react-common';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import OpenCalenderModal from '../common/Modal/OpenCalenderModal';
import DateField from '../common/TextField/dateTime';
import {
  recurrenceStructring,
  totalShiftAmountCalculation,
  updateMonth,
  updateRepeat,
  updateShift,
  updateWeek,
  updateYear,
} from './action';
import { jobOpportunitySelector } from './selector';
import { setShowCalenderModal, setjobMultishiftOccurreneUpdateList } from './slice';
import { RRule } from 'rrule'
import { payRateTypeObj } from '../../helpers/data';

const MultiShift = (props) => {
  const {
    masterData,
    shift,
    repeatEvery,
    byWeeks,
    byMonths,
    byYear,
    rrurleStr,
    rrurle,
    jobMultishiftOccurreneUpdateList,
    location,
    jobInfo,
    showCalenderModal,
    payRateType,
    payRateOccurrenceAmount
  } = useSelector(jobOpportunitySelector);
  console.log('------->', payRateOccurrenceAmount, payRateType);
  // const [showCalenderModal, setShowCalenderModal] = useState(false);
  const [firstClick, setFirstClick] = useState(false);
  const [multiShiftData, setMultiShiftData] = useState([]);
  const [shiftDateError, SetShiftDateError] = useState(false);
  const dispatch = useDispatch();
  const repeat = useRef();
  const month = useRef();
  const year = useRef();
  useEffect(() => {
    if (firstClick && shift?.date) {
      const currentMonthDay = moment(shift?.date, 'YYYY-MM-DD').format('DD');
      dispatch(updateMonth({ data: currentMonthDay, type: 'onday' })).then(
        () => {
          dispatch(recurrenceStructring());
        }
      );
    }
  }, [firstClick]);

  useEffect(() => {
    if (repeatEvery.on !== '') {
      repeat.current = repeatEvery.on;
    }
    if (byMonths?.onDay !== '') {
      month.current = byMonths?.onDay;
    }
    if (byYear?.on?.position !== '') {
      year.current = byMonths?.onDay;
    }
  }, [repeatEvery.on, byMonths?.onDay, byYear?.on?.position]);

  useEffect(() => {
    document.addEventListener('click', clickoutSide, false);
    return () => {
      document.removeEventListener('click', clickoutSide, false);
    };
  }, [repeatEvery.on, byMonths?.onDay, byYear?.on?.position]);

  const clickoutSide = (event) => {
    // console.log(repeat.current);
    if (!repeatEvery.on || repeatEvery.on === '') {
      const payload = { field: 'on', data: repeat.current, fullData: false };
      //  console.log('call');
      dispatch(updateRepeat(payload)).then(() => {
        dispatch(recurrenceStructring());
      });
    } else if (!byMonths?.onDay || byMonths?.onDay === '') {
      const payload = { type: 'onday', data: month.current, fullData: false };
      dispatch(updateMonth(payload)).then(() => {
        dispatch(recurrenceStructring());
      });
    } else if (!byYear?.on?.position || byYear?.on?.position === '') {
      const payload = {
        type: 'on',
        data: year.current,
        field: 'position',
        fullData: false,
      };
      dispatch(updateYear(payload)).then(() => {
        dispatch(recurrenceStructring());
      });
    }
  };

  const updateShiftDetails = (target) => {
    const value = target.value;
    dispatch(setShowCalenderModal(false))
    dispatch(setjobMultishiftOccurreneUpdateList([]));
    if (target.action === 'remove') {
      dispatch(updateShift(target.name, ''));
    } else {
      dispatch(updateShift(target.name, value)).then(() => {
        dispatch(recurrenceStructring());
      });
    }
  };

  const repeateveryOn = (target) => {
    // console.log(target.name, target.value)
    //const re = /^[0-9\b]+$/;
    const re = /^(\s*|\d+)$/;
    // console.log(re.test(target.value));
    // target.value !== '' &&
    if (re.test(target.value) && target.value !== '0') {
      if (target.name === 'on') {
        const payload = {
          field: target.name,
          data: target.value,
          fullData: false,
        };
        dispatch(updateRepeat(payload)).then(() => {
          dispatch(recurrenceStructring());
        });
      } else if (target.name === 'month') {
        const payload = {
          type: byMonths?.checkedBy,
          data: target.value,
          fullData: false,
        };
        dispatch(updateMonth(payload)).then(() => {
          dispatch(recurrenceStructring());
        });
      } else if (target.name === 'year') {
        const payload = {
          type: byYear?.checkedBy,
          data: target.value,
          field: 'position',
          fullData: false,
        };
        dispatch(updateYear(payload)).then(() => {
          dispatch(recurrenceStructring());
        });
      }
    }
  };

  const repeateveryType = (target) => {
    if (target.value === 'MONTHLY') {
      if (shift?.date === '') {
        SetShiftDateError(true);
        return;
      }
      else {
        SetShiftDateError(false);
      }
    } else {
      SetShiftDateError(false);
    }
    const payload = { field: target.name, data: target.value, fullData: false };
    if (target.name !== '') {
      dispatch(updateRepeat(payload)).then(() => {
        dispatch(recurrenceStructring());
      });
    }
  };

  const weeksSelect = (target, val) => {
    //console.log(target.checked, val);
    const week = JSON.parse(JSON.stringify(byWeeks));
    console.log(week, '============');
    dispatch(setShowCalenderModal(false))
    dispatch(setjobMultishiftOccurreneUpdateList([]));
    if (target.checked) {
      week.push(val.id);
      dispatch(updateWeek(week)).then(() => {
        dispatch(recurrenceStructring());
      });
    } else {
      const newval = week.filter((val2) => val2 !== val.id);
      // console.log('out', newval)
      if (week?.length > 1) {
        dispatch(updateWeek(newval)).then(() => {
          dispatch(recurrenceStructring());
        });
      }
    }
    dispatch(totalShiftAmountCalculation());
  };

  const monthSelect = (target) => {
    // console.log(target.value, target.name);
    dispatch(setShowCalenderModal(false))
    dispatch(setjobMultishiftOccurreneUpdateList([]));
    if (target.value !== '') {
      const payload = {
        type: byMonths?.checkedBy,
        data: target.value,
        field: target.name,
        fullData: false,
      };
      dispatch(updateMonth(payload)).then(() => {
        dispatch(recurrenceStructring());
      });
    }
  };
  const monthType = (target) => {
    // console.log(target.value, target.name)
    dispatch(setShowCalenderModal(false))
    dispatch(setjobMultishiftOccurreneUpdateList([]));
    if (target.name) {
      // const payload = { type: target.name };
      const payload = { type: target.name, data: byMonths?.onDay };
      dispatch(updateMonth(payload)).then(() => {
        dispatch(recurrenceStructring());
      });
    }
  };

  const yearType = (target) => {
    dispatch(setShowCalenderModal(false))
    dispatch(setjobMultishiftOccurreneUpdateList([]));
    if (target.name) {
      const payload = { type: target.name };
      dispatch(updateYear(payload)).then(() => {
        dispatch(recurrenceStructring());
      });
    }
  };

  const yearSelect = (target) => {
    dispatch(setShowCalenderModal(false))
    dispatch(setjobMultishiftOccurreneUpdateList([]));
    if (target.value !== '') {
      const payload = {
        type: byYear?.checkedBy,
        data: target.value,
        field: target.name,
        fullData: false,
      };
      console.log(payload);
      dispatch(updateYear(payload)).then(() => {
        dispatch(recurrenceStructring());
      });
    }
  };

  const handleCalenderModalClose = () => {
    // console.log(rrurle);
    // console.log(shift.date, shift.startTime.name);
    // console.log(`DTSTART:${moment(shift.date).format('YYYYMMDDTHHmmss')}Z\nRRULE:${rrurle}`);
    // const days = RRule.fromString(`DTSTART:${moment(shift.date).format('YYYYMMDDTHHmmss')}Z\nRRULE:${rrurle}`)
    // console.log(days.all());
    // days.all().map(item => {
    //   const newDate = moment(item).format('YYYY-MM-DD')
    //   // console.log(typeof item);
    //   // console.log(item);
    //   console.log(new Date(moment(
    //     newDate + ' ' + shift.startTime.name,
    //     'YYYY-MM-DD H:mm A'
    //   )));
    // })
    // console.log(moment(
    //   shift.date + ' ' + shift.startTime.name,
    //   'YYYY-MM-DD H:mm A'
    // ));
    // console.log(shift.preferedShift, '======================');
    if (
      jobMultishiftOccurreneUpdateList &&
      !jobMultishiftOccurreneUpdateList.length &&
      rrurle
    ) {
      let shiftStartDate = shift.date;
      let shiftEndDdate = shift.date;
      const startTime = moment(shift.startTime?.id, 'hh:mm');
      const endTime = moment(shift.endTime?.id, 'hh:mm');
      const InMinutes = moment.duration(endTime.diff(startTime)).asMinutes();
      if (InMinutes <= 0) {
        shiftEndDdate = moment(shift.date).add(1, 'day').format('YYYY-MM-DD');
      }
      const startDateFormat = moment(
        shiftStartDate + ' ' + shift.startTime.name,
        'YYYY-MM-DD H:mm A'
      );
      const endDateFormat = moment(
        shiftEndDdate + ' ' + shift.endTime.name,
        'YYYY-MM-DD H:mm A'
      );

      const calenderRequestBody = {
        TaskID: guid(),
        ownerID: guid(),
        Title: 'Shift Info',
        Description: '',
        StartTimezone: null,
        Start: new Date(startDateFormat),
        End: new Date(endDateFormat),
        EndTimezone: null,
        RecurrenceRule: rrurle,
        RecurrenceID: null,
        RecurrenceException: [],
        isAllDay: false,
        locationId: location.locationNameInfo?.id,
        jobsContactsList: location.contactPersons.map(item => item.id),
        jobsApproversList: location.approvalUsers.map(item => item.id),
        billingrate: jobInfo?.billingrate ? jobInfo?.billingrate : '',
        shiftLength: shift.preferedShift?.id ? shift.preferedShift?.id : '',
        editDay: false,
        payRateOccurrenceAmount: payRateType === payRateTypeObj.manualCal ? payRateOccurrenceAmount : null
      };

      setMultiShiftData((preVal) => {
        return [calenderRequestBody];
      });
    } else {
      setMultiShiftData((preVal) => {
        return jobMultishiftOccurreneUpdateList.map((element, index) => {
          const { Start, End, RecurrenceException, editDay, ...rest } = element;
          return {
            ...rest,
            Start: new Date(Start),
            End: new Date(End),
            editDay: editDay,
            RecurrenceException: RecurrenceException?.length
              ? RecurrenceException.map((DateElement, index) => {
                return new Date(DateElement);
              })
              : RecurrenceException,
          };
        });
      });
    }

    dispatch(setShowCalenderModal(!showCalenderModal))
  };

  const handleCalenderModalSave = (value) => {
    console.log(`🚀 ~ file: multishift.js ~ line: 188 :`, { value });
    dispatch(
      setjobMultishiftOccurreneUpdateList(JSON.parse(JSON.stringify(value)))
    );
    dispatch(totalShiftAmountCalculation());
  };

  const getCalendarData = () => {
    if (jobMultishiftOccurreneUpdateList && jobMultishiftOccurreneUpdateList?.length) {
      return jobMultishiftOccurreneUpdateList.map((element, index) => {
        const { Start, End, RecurrenceException, editDay, ...rest } = element;
        return {
          ...rest,
          Start: new Date(Start),
          End: new Date(End),
          editDay: editDay,
          RecurrenceException: RecurrenceException?.length
            ? RecurrenceException.map((DateElement, index) => {
              return new Date(DateElement);
            })
            : RecurrenceException,
        };
      });
    } else {
      return []
    }
  }

  return (
    <>
      <div className="row">
        <div className="col-lg-3 d-flex gap-3 align-items-center">
          <span className="my-4 d-inline-block text-nowrap">Repeat Every</span>
          <input
            type={'text'}
            style={{ width: "auto" }}
            className="form-control"
            name="on"
            value={repeatEvery.on}
            onChange={(event) => repeateveryOn(event.target)}
          />
          <select
            className="form-select recurssion-select"
            style={{ width: "auto" }}
            name="type"
            value={repeatEvery.type}
            onChange={(e) => {
              repeateveryType(e.target);
            }}
          >
            {masterData?.repeatData?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
          {shiftDateError && (
            <div className="invalid-input">Select shift date</div>
          )}
        </div>
      </div>
      <div className="row mt-4">
        {repeatEvery?.type === 'WEEKLY' ? (
          <Weeks
            data={masterData.daysData}
            weeksSelect={weeksSelect}
            byWeeks={byWeeks}
          />
        ) : repeatEvery?.type === 'MONTHLY' ? (
          <Month
            days={masterData.daysData}
            startby={masterData.startbyData}
            monthType={monthType}
            monthSelect={monthSelect}
            byMonths={byMonths}
            repeateveryOn={repeateveryOn}
            setFirstClick={setFirstClick}
          />
        ) : repeatEvery?.type === 'YEARLY' ? (
          <Year
            days={masterData.daysData}
            startby={masterData.startbyData}
            months={masterData.monthsData}
            repeateveryOn={repeateveryOn}
            yearType={yearType}
            byYear={byYear}
            yearSelect={yearSelect}
          />
        ) : (
          ''
        )}
      </div>
      <div className="row mt-4">
        <div className="col-sm-6">
          {/* <DateField
            name={'endDate'}
            star="*"
            // divClass="col-lg-3 col-md-3"
            label={'End Date'}
            id={'enddate'}
            value={shift?.endDate}
            updateValue={updateShiftDetails}
            includeTime={false}
            errors={props.errors['endDate']}
            isMandatory={'yes'}

          /> */}
        </div>
        {/* <div className="col-sm-6">
         
        </div> */}
      </div>
      <div className="row ">
        <div className="d-flex align-items-center justify-content-between">
          <span className="fw-bolder">{rrurleStr}</span>
          <div>
            <Button variant="primary" className='pull-right' onClick={handleCalenderModalClose}>
              {showCalenderModal ? 'Close' : 'Show'} Modify Occurrence
            </Button>
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-sm-12">
          {showCalenderModal ? (
            <OpenCalenderModal
              showCalenderModal={showCalenderModal}
              handleClose={handleCalenderModalClose}
              handleSave={handleCalenderModalSave}
              multiShiftData={multiShiftData?.length ? multiShiftData : getCalendarData}
              startDate={shift.date}
            />
          ) : null}
        </div>
      </div>
    </>
  );
};

export const Weeks = ({ data, weeksSelect, byWeeks }) => {
  // console.log('data=======',data)
  return (
    <div className="d-flex">
      {data?.map((item) => (
        <div
          key={item.id}
          className={`date-checkbox ${byWeeks.indexOf(item.id) > -1 ? 'activeday' : ''
            }`}
        >
          <label htmlFor="">{item.shortname}</label>
          <input
            type="checkbox"
            className=""
            name=""
            checked={byWeeks.indexOf(item.id) > -1}
            onChange={(e) => weeksSelect(e.target, item)}
          />
        </div>
      ))}
    </div>
  );
};

export const Month = ({
  days,
  startby,
  monthType,
  byMonths,
  repeateveryOn,
  monthSelect,
  setFirstClick,
}) => {
  return (
    <>
      <div className="row">
        <div className="col-lg-3 col-md-3 d-flex gap-3">
          <input
            type={'radio'}
            name="onday"
            className="mt-2"
            onClick={() => setFirstClick(true)}
            onChange={(e) => monthType(e.target)}
            checked={byMonths.checkedBy === 'onday'}
          />
          <span className="mt-3 text-nowrap">On day</span>
          <input
            disabled={byMonths.checkedBy !== 'onday'}
            name="month"
            type={'text'}
            value={byMonths?.onDay}
            className="form-control w-25 disbleclass"
            onChange={(event) => repeateveryOn(event.target)}
          />
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-lg-5 col-md-5 d-flex gap-3">
          <input
            type={'radio'}
            name="onthe"
            className="mt-2"
            onChange={(e) => monthType(e.target)}
            checked={byMonths.checkedBy === 'onthe'}
          />
          <span className="mt-3 text-nowrap">On the</span>
          <select
            className="form-select recurssion-select"
            name="position"
            value={byMonths?.onthe?.position}
            disabled={byMonths.checkedBy !== 'onthe'}
            onChange={(e) => {
              monthSelect(e.target);
            }}
          >
            {startby?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
          <select
            className="form-select recurssion-select"
            name="day"
            disabled={byMonths.checkedBy !== 'onthe'}
            value={byMonths?.onthe?.day}
            onChange={(e) => {
              monthSelect(e.target);
            }}
          >
            {days?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </>
  );
};

export const Year = ({
  startby,
  days,
  repeateveryOn,
  yearSelect,
  months,
  yearType,
  byYear,
}) => {
  return (
    <>
      <div className="row">
        <div className="col-lg-4 col-md-4 d-flex gap-3">
          <input
            type={'radio'}
            name="on"
            className="mt-2"
            onChange={(e) => yearType(e.target)}
            checked={byYear.checkedBy === 'on'}
          />
          <span className="mt-3 text-nowrap">On</span>
          <select
            className="form-select recurssion-select"
            name="month"
            disabled={byYear.checkedBy !== 'on'}
            value={byYear?.on?.month}
            onChange={(e) => {
              yearSelect(e.target);
            }}
          >
            {months?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
          <input
            name="year"
            disabled={byYear.checkedBy !== 'on'}
            value={byYear?.on?.position}
            type={'text'}
            className="form-control w-50 disbleclass"
            onChange={(event) => repeateveryOn(event.target)}
          />
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-lg-7 col-md-7 d-flex gap-3">
          <input
            type={'radio'}
            name="onthe"
            className="mt-2"
            onChange={(e) => yearType(e.target)}
            checked={byYear.checkedBy === 'onthe'}
          />
          <span className="mt-3 text-nowrap">On the</span>
          <select
            className="form-select recurssion-select"
            name="position"
            value={byYear?.onthe?.position}
            disabled={byYear.checkedBy !== 'onthe'}
            onChange={(e) => {
              yearSelect(e.target);
            }}
          >
            {startby?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
          <select
            className="form-select recurssion-select"
            name="day"
            disabled={byYear.checkedBy !== 'onthe'}
            value={byYear?.onthe?.day}
            onChange={(e) => {
              yearSelect(e.target);
            }}
          >
            {days?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
          <span className="mt-3 text-nowrap">of</span>
          <select
            className="form-select recurssion-select"
            name="month"
            disabled={byYear.checkedBy !== 'onthe'}
            value={byYear?.onthe?.month}
            onChange={(e) => {
              yearSelect(e.target);
            }}
          >
            {months?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </>
  );
};

export default MultiShift;
